export const floatingLabels = {
	init: function(formContainer) {
		if (!formContainer) return;
		this.allFields = formContainer.querySelectorAll('.form-group');
		if (!this.allFields) return;
		this.forgottenPasswordContainer = formContainer.querySelector('.jsDynamicallyAdded');
		this.selectSingleField(this.allFields);
		if (this.forgottenPasswordContainer) this.dynamicallyFieldObserver();
	},

	selectSingleField: function(allFields) {
		[].slice.call(allFields).forEach((field)=> {
			const input = field.querySelector('input, textarea'),
				  label = field.querySelector('label, .editing-form-label');
				  if (!input || !label) return;
			this.assignEventListeners(input, label);
			this.autofillInputsFix(input, label);
		});
	},

	assignEventListeners: function(input, label) {
		if (input.value) {
			label.classList.add("control-label--active");
		}

		input.addEventListener('focus', e=> {
			label.classList.add('control-label--active');
		});

		input.addEventListener('change', e=> {
			label.classList.add('control-label--active');
		});

		label.addEventListener('click', e=> {
			label.classList.add('control-label--active');
			input.focus();
		});

		input.addEventListener('blur', e=> {
			if (!input.value) {
				label.classList.remove('control-label--active');
			}
		});
	},

	autofillInputsFix: function(input, label) {
		const autofilledClass = 'control-label--active-autofilled';
		const onAutoFillStart = (el) => el.classList.add(autofilledClass);
		const onAutoFillCancel = (el) => el.classList.remove(autofilledClass);

		input.addEventListener('animationstart', ({target, animationName})=> {
			switch (animationName) {
				case 'onAutoFillStart':
					return onAutoFillStart(label);
				case 'onAutoFillCancel':
					return onAutoFillCancel(label);
			}
		});
	},

	dynamicallyFieldObserver: function() {
		const observer = new MutationObserver((mutations)=> {
			mutations.forEach((mutation)=> {
				const addedField = mutation.addedNodes[1].querySelectorAll('.form-group');
				this.selectSingleField(addedField);
			});
		});
		const config = { attributes: false, childList: true, characterData: false }
		observer.observe(this.forgottenPasswordContainer, config);
	}
}
